<div class="login-dialog">
  <h4 class="alterar-senha-title" id="forgot-password-title">Esqueceu a senha?</h4>
  <form
    class="alterar-senha-form login-dialog__body"
    autocomplete="off"
    (input)="validationMessage = ''"
    (keydown.enter)="confirmFromEnter($event)"
  >
    <p class="alterar-senha-form__hint">
      Informe o e-mail cadastrado. Enviaremos as instruções para redefinir sua senha.
    </p>

    <div class="alterar-senha-form__field">
      <label for="forgot-password-email" class="alterar-senha-form__label">
        <span class="material-symbols-outlined" aria-hidden="true">mail</span>
        E-mail
      </label>
      <div class="alterar-senha-form__input-wrap">
        <input
          #emailInput
          type="email"
          id="forgot-password-email"
          class="alterar-senha-form__input alterar-senha-form__input--plain"
          placeholder="Digite seu e-mail"
          aria-label="E-mail"
          autocomplete="email"
          inputmode="email"
          [formControl]="email"
          [class.is-invalid]="!!validationMessage"
        />
      </div>
    </div>
  </form>

  @if (validationMessage) {
    <p class="login-dialog__message" role="alert">{{ validationMessage }}</p>
  }

  <div class="login-dialog__actions">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      Cancelar
    </button>
    <button type="button" class="btn btn-ergon btn-shadow" (click)="confirm()">
      Enviar
    </button>
  </div>
</div>
